// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-toggler .toggler-btn {
  outline: none;
  width: 48px;
  border: none;
  background-color: transparent;
  margin-right: 10px;
  color: var(--secondary-on-surface, #98a2b3);
}
.navbar-toggler .toggler-btn svg {
  vertical-align: middle;
}
.navbar-toggler .tablet-sidebar {
  background: var(--secondary-surface, #f9fafb);
  min-width: 300px;
  max-width: 100vw;
  height: calc(100vh - 80px);
  position: absolute;
  top: 80px;
  left: 0;
  padding: 40px 10px;
}
.navbar-toggler .tablet-sidebar .tablet-sidebar-menu .tablet-sidebar-menu-item .tablet-sidebar-menu-link {
  width: 100%;
  padding: 15px 22px;
  display: block;
  color: var(--secondary-text, #667085);
  font-size: 14px !important;
  font-weight: 500;
  text-decoration: none;
  line-height: 21px;
}
.navbar-toggler .tablet-sidebar .tablet-sidebar-menu .tablet-sidebar-menu-item .tablet-sidebar-menu-link svg {
  margin-right: 24px;
}
.navbar-toggler .tablet-sidebar .tablet-sidebar-menu .tablet-sidebar-menu-item .tablet-sidebar-menu-link svg path {
  stroke: var(--Secondary-On-Surface, #98a2b3);
}
.navbar-toggler .tablet-sidebar .tablet-sidebar-menu .tablet-sidebar-menu-item .tablet-sidebar-menu-link span {
  vertical-align: top;
}
.navbar-toggler .tablet-sidebar .tablet-sidebar-menu .tablet-sidebar-menu-item.active {
  border-radius: var(--corner-radius-main, 8px);
  background: var(--primary-100, #f4ebff);
}
.navbar-toggler .tablet-sidebar .tablet-sidebar-menu .tablet-sidebar-menu-item.active .tablet-sidebar-menu-link {
  color: #7f56d9 !important;
}
.navbar-toggler .tablet-sidebar .tablet-sidebar-menu .tablet-sidebar-menu-item.active svg > path {
  stroke: #7f56d9 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/header/navbar-toggler/styles.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,2CAAA;AAAJ;AAEI;EACE,sBAAA;AAAN;AAIE;EACE,6CAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;AAFJ;AAMQ;EACE,WAAA;EACA,kBAAA;EAEA,cAAA;EACA,qCAAA;EACA,0BAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;AALV;AAOU;EACE,kBAAA;AALZ;AAOY;EACE,4CAAA;AALd;AASU;EACE,mBAAA;AAPZ;AAWQ;EACE,6CAAA;EACA,uCAAA;AATV;AAWU;EACE,yBAAA;AATZ;AAYU;EACE,0BAAA;AAVZ","sourcesContent":[".navbar-toggler {\n  .toggler-btn {\n    outline: none;\n    width: 48px;\n    border: none;\n    background-color: transparent;\n    margin-right: 10px;\n    color: var(--secondary-on-surface, #98a2b3);\n\n    svg {\n      vertical-align: middle;\n    }\n  }\n\n  .tablet-sidebar {\n    background: var(--secondary-surface, #f9fafb);\n    min-width: 300px;\n    max-width: 100vw;\n    height: calc(100vh - 80px);\n    position: absolute;\n    top: 80px;\n    left: 0;\n    padding: 40px 10px;\n\n    .tablet-sidebar-menu {\n      .tablet-sidebar-menu-item {\n        .tablet-sidebar-menu-link {\n          width: 100%;\n          padding: 15px 22px;\n\n          display: block;\n          color: var(--secondary-text, #667085);\n          font-size: 14px !important;\n          font-weight: 500;\n          text-decoration: none;\n          line-height: 21px;\n\n          svg {\n            margin-right: 24px;\n\n            path {\n              stroke: var(--Secondary-On-Surface, #98a2b3);\n            }\n          }\n\n          span {\n            vertical-align: top;\n          }\n        }\n\n        &.active {\n          border-radius: var(--corner-radius-main, 8px);\n          background: var(--primary-100, #f4ebff);\n\n          .tablet-sidebar-menu-link {\n            color: #7f56d9 !important;\n          }\n\n          svg > path {\n            stroke: #7f56d9 !important;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
